[
  {
    "tenantKey": "GLS_ES",
    "tomorrowPickUpCutOffTime": "23:00",
    "countryKey": "AD",
    "maxParcelWeightThreshold": "40",
    "countryName": "Andorra",
    "onboarded": false,
    "validDeliveryCountries": [
      {
        "countryKey": "AD",
        "countryName": "Andorra"
      },
      {
        "countryKey": "AT",
        "countryName": "Austria"
      },
      {
        "countryKey": "BE",
        "countryName": "Belgium"
      },
      {
        "countryKey": "BG",
        "countryName": "Bulgaria"
      },
      {
        "countryKey": "HR",
        "countryName": "Croatia"
      },
      {
        "countryKey": "CY",
        "countryName": "Cyprus"
      },
      {
        "countryKey": "CZ",
        "countryName": "Czech Republic"
      },
      {
        "countryKey": "DK",
        "countryName": "Denmark"
      },
      {
        "countryKey": "EE",
        "countryName": "Estonia"
      },
      {
        "countryKey": "FI",
        "countryName": "Finland"
      },
      {
        "countryKey": "FR",
        "countryName": "France"
      },
      {
        "countryKey": "DE",
        "countryName": "Germany"
      },
      {
        "countryKey": "GI",
        "countryName": "Gibraltar"
      },
      {
        "countryKey": "GR",
        "countryName": "Greece"
      },
      {
        "countryKey": "HU",
        "countryName": "Hungary"
      },
      {
        "countryKey": "IE",
        "countryName": "Ireland"
      },
      {
        "countryKey": "IT",
        "countryName": "Italy"
      },
      {
        "countryKey": "LV",
        "countryName": "Latvia"
      },
      {
        "countryKey": "LI",
        "countryName": "Liechtenstein"
      },
      {
        "countryKey": "LT",
        "countryName": "Lithuania"
      },
      {
        "countryKey": "LU",
        "countryName": "Luxemburg"
      },
      {
        "countryKey": "MT",
        "countryName": "Malta"
      },
      {
        "countryKey": "MC",
        "countryName": "Monaco"
      },
      {
        "countryKey": "NL",
        "countryName": "Netherlands"
      },
      {
        "countryKey": "NO",
        "countryName": "Norway"
      },
      {
        "countryKey": "PT",
        "countryName": "Portugal"
      },
      {
        "countryKey": "RO",
        "countryName": "Romania"
      },
      {
        "countryKey": "RS",
        "countryName": "Serbia"
      },
      {
        "countryKey": "SK",
        "countryName": "Slovakia"
      },
      {
        "countryKey": "SI",
        "countryName": "Slovenia"
      },
      {
        "countryKey": "SE",
        "countryName": "Sweden"
      },
      {
        "countryKey": "CH",
        "countryName": "Switzerland"
      },
      {
        "countryKey": "GB",
        "countryName": "United Kingdom"
      },
      {
        "countryKey": "VA",
        "countryName": "Vatican City"
      }
    ]
  },
  {
    "tenantKey": "GLS_ES",
    "tomorrowPickUpCutOffTime": "23:00",
    "countryKey": "ES",
    "maxParcelWeightThreshold": "40",
    "countryName": "Spain",
    "onboarded": false,
    "validDeliveryCountries": [
      {
        "countryKey": "AD",
        "countryName": "Andorra"
      },
      {
        "countryKey": "AT",
        "countryName": "Austria"
      },
      {
        "countryKey": "BE",
        "countryName": "Belgium"
      },
      {
        "countryKey": "BG",
        "countryName": "Bulgaria"
      },
      {
        "countryKey": "HR",
        "countryName": "Croatia"
      },
      {
        "countryKey": "CY",
        "countryName": "Cyprus"
      },
      {
        "countryKey": "CZ",
        "countryName": "Czech Republic"
      },
      {
        "countryKey": "DK",
        "countryName": "Denmark"
      },
      {
        "countryKey": "EE",
        "countryName": "Estonia"
      },
      {
        "countryKey": "FI",
        "countryName": "Finland"
      },
      {
        "countryKey": "FR",
        "countryName": "France"
      },
      {
        "countryKey": "DE",
        "countryName": "Germany"
      },
      {
        "countryKey": "GI",
        "countryName": "Gibraltar"
      },
      {
        "countryKey": "GR",
        "countryName": "Greece"
      },
      {
        "countryKey": "HU",
        "countryName": "Hungary"
      },
      {
        "countryKey": "IE",
        "countryName": "Ireland"
      },
      {
        "countryKey": "IT",
        "countryName": "Italy"
      },
      {
        "countryKey": "LV",
        "countryName": "Latvia"
      },
      {
        "countryKey": "LI",
        "countryName": "Liechtenstein"
      },
      {
        "countryKey": "LT",
        "countryName": "Lithuania"
      },
      {
        "countryKey": "LU",
        "countryName": "Luxemburg"
      },
      {
        "countryKey": "MT",
        "countryName": "Malta"
      },
      {
        "countryKey": "MC",
        "countryName": "Monaco"
      },
      {
        "countryKey": "NL",
        "countryName": "Netherlands"
      },
      {
        "countryKey": "NO",
        "countryName": "Norway"
      },
      {
        "countryKey": "PT",
        "countryName": "Portugal"
      },
      {
        "countryKey": "RO",
        "countryName": "Romania"
      },
      {
        "countryKey": "RS",
        "countryName": "Serbia"
      },
      {
        "countryKey": "SK",
        "countryName": "Slovakia"
      },
      {
        "countryKey": "SI",
        "countryName": "Slovenia"
      },
      {
        "countryKey": "SE",
        "countryName": "Sweden"
      },
      {
        "countryKey": "CH",
        "countryName": "Switzerland"
      },
      {
        "countryKey": "GB",
        "countryName": "United Kingdom"
      },
      {
        "countryKey": "VA",
        "countryName": "Vatican City"
      }
    ]
  },
  {
    "tenantKey": "GLS_IT",
    "tomorrowPickUpCutOffTime": "16:00",
    "countryKey": "IT",
    "maxParcelWeightThreshold": "40",
    "countryName": "Italy",
    "onboarded": true,
    "validDeliveryCountries": [
      {
        "countryKey": "AD",
        "countryName": "Andorra"
      },
      {
        "countryKey": "AT",
        "countryName": "Austria"
      },
      {
        "countryKey": "BE",
        "countryName": "Belgium"
      },
      {
        "countryKey": "BG",
        "countryName": "Bulgaria"
      },
      {
        "countryKey": "HR",
        "countryName": "Croatia"
      },
      {
        "countryKey": "CY",
        "countryName": "Cyprus"
      },
      {
        "countryKey": "CZ",
        "countryName": "Czech Republic"
      },
      {
        "countryKey": "DK",
        "countryName": "Denmark"
      },
      {
        "countryKey": "EE",
        "countryName": "Estonia"
      },
      {
        "countryKey": "FI",
        "countryName": "Finland"
      },
      {
        "countryKey": "FR",
        "countryName": "France"
      },
      {
        "countryKey": "DE",
        "countryName": "Germany"
      },
      {
        "countryKey": "GI",
        "countryName": "Gibraltar"
      },
      {
        "countryKey": "GR",
        "countryName": "Greece"
      },
      {
        "countryKey": "HU",
        "countryName": "Hungary"
      },
      {
        "countryKey": "IE",
        "countryName": "Ireland"
      },
      {
        "countryKey": "LV",
        "countryName": "Latvia"
      },
      {
        "countryKey": "LI",
        "countryName": "Liechtenstein"
      },
      {
        "countryKey": "LT",
        "countryName": "Lithuania"
      },
      {
        "countryKey": "LU",
        "countryName": "Luxemburg"
      },
      {
        "countryKey": "MT",
        "countryName": "Malta"
      },
      {
        "countryKey": "MC",
        "countryName": "Monaco"
      },
      {
        "countryKey": "NL",
        "countryName": "Netherlands"
      },
      {
        "countryKey": "NO",
        "countryName": "Norway"
      },
      {
        "countryKey": "PT",
        "countryName": "Portugal"
      },
      {
        "countryKey": "RO",
        "countryName": "Romania"
      },
      {
        "countryKey": "RS",
        "countryName": "Serbia"
      },
      {
        "countryKey": "SK",
        "countryName": "Slovakia"
      },
      {
        "countryKey": "SI",
        "countryName": "Slovenia"
      },
      {
        "countryKey": "ES",
        "countryName": "Spain"
      },
      {
        "countryKey": "SE",
        "countryName": "Sweden"
      },
      {
        "countryKey": "CH",
        "countryName": "Switzerland"
      },
      {
        "countryKey": "GB",
        "countryName": "United Kingdom"
      },
      {
        "countryKey": "VA",
        "countryName": "Vatican City"
      }
    ]
  },
  {
    "tenantKey": "GLS_IT",
    "tomorrowPickUpCutOffTime": "16:00",
    "countryKey": "VA",
    "maxParcelWeightThreshold": "40",
    "countryName": "Vatican City",
    "onboarded": false,
    "validDeliveryCountries": [
      {
        "countryKey": "AD",
        "countryName": "Andorra"
      },
      {
        "countryKey": "AT",
        "countryName": "Austria"
      },
      {
        "countryKey": "BE",
        "countryName": "Belgium"
      },
      {
        "countryKey": "BG",
        "countryName": "Bulgaria"
      },
      {
        "countryKey": "HR",
        "countryName": "Croatia"
      },
      {
        "countryKey": "CY",
        "countryName": "Cyprus"
      },
      {
        "countryKey": "CZ",
        "countryName": "Czech Republic"
      },
      {
        "countryKey": "DK",
        "countryName": "Denmark"
      },
      {
        "countryKey": "EE",
        "countryName": "Estonia"
      },
      {
        "countryKey": "FI",
        "countryName": "Finland"
      },
      {
        "countryKey": "FR",
        "countryName": "France"
      },
      {
        "countryKey": "DE",
        "countryName": "Germany"
      },
      {
        "countryKey": "GI",
        "countryName": "Gibraltar"
      },
      {
        "countryKey": "GR",
        "countryName": "Greece"
      },
      {
        "countryKey": "HU",
        "countryName": "Hungary"
      },
      {
        "countryKey": "IE",
        "countryName": "Ireland"
      },
      {
        "countryKey": "IT",
        "countryName": "Italy"
      },
      {
        "countryKey": "LV",
        "countryName": "Latvia"
      },
      {
        "countryKey": "LI",
        "countryName": "Liechtenstein"
      },
      {
        "countryKey": "LT",
        "countryName": "Lithuania"
      },
      {
        "countryKey": "LU",
        "countryName": "Luxemburg"
      },
      {
        "countryKey": "MT",
        "countryName": "Malta"
      },
      {
        "countryKey": "MC",
        "countryName": "Monaco"
      },
      {
        "countryKey": "NL",
        "countryName": "Netherlands"
      },
      {
        "countryKey": "NO",
        "countryName": "Norway"
      },
      {
        "countryKey": "PT",
        "countryName": "Portugal"
      },
      {
        "countryKey": "RO",
        "countryName": "Romania"
      },
      {
        "countryKey": "RS",
        "countryName": "Serbia"
      },
      {
        "countryKey": "SK",
        "countryName": "Slovakia"
      },
      {
        "countryKey": "SI",
        "countryName": "Slovenia"
      },
      {
        "countryKey": "ES",
        "countryName": "Spain"
      },
      {
        "countryKey": "SE",
        "countryName": "Sweden"
      },
      {
        "countryKey": "CH",
        "countryName": "Switzerland"
      },
      {
        "countryKey": "GB",
        "countryName": "United Kingdom"
      }
    ]
  },
  {
    "tenantKey": "PARTNER_ACSGR",
    "tomorrowPickUpCutOffTime": "16:00",
    "countryKey": "GR",
    "maxParcelWeightThreshold": "40",
    "countryName": "Greece",
    "onboarded": true,
    "validDeliveryCountries": [
      {
        "countryKey": "AD",
        "countryName": "Andorra"
      },
      {
        "countryKey": "AT",
        "countryName": "Austria"
      },
      {
        "countryKey": "BE",
        "countryName": "Belgium"
      },
      {
        "countryKey": "BG",
        "countryName": "Bulgaria"
      },
      {
        "countryKey": "HR",
        "countryName": "Croatia"
      },
      {
        "countryKey": "CY",
        "countryName": "Cyprus"
      },
      {
        "countryKey": "CZ",
        "countryName": "Czech Republic"
      },
      {
        "countryKey": "DK",
        "countryName": "Denmark"
      },
      {
        "countryKey": "EE",
        "countryName": "Estonia"
      },
      {
        "countryKey": "FI",
        "countryName": "Finland"
      },
      {
        "countryKey": "FR",
        "countryName": "France"
      },
      {
        "countryKey": "DE",
        "countryName": "Germany"
      },
      {
        "countryKey": "GI",
        "countryName": "Gibraltar"
      },
      {
        "countryKey": "HU",
        "countryName": "Hungary"
      },
      {
        "countryKey": "IE",
        "countryName": "Ireland"
      },
      {
        "countryKey": "IT",
        "countryName": "Italy"
      },
      {
        "countryKey": "LV",
        "countryName": "Latvia"
      },
      {
        "countryKey": "LI",
        "countryName": "Liechtenstein"
      },
      {
        "countryKey": "LT",
        "countryName": "Lithuania"
      },
      {
        "countryKey": "LU",
        "countryName": "Luxemburg"
      },
      {
        "countryKey": "MT",
        "countryName": "Malta"
      },
      {
        "countryKey": "MC",
        "countryName": "Monaco"
      },
      {
        "countryKey": "NL",
        "countryName": "Netherlands"
      },
      {
        "countryKey": "NO",
        "countryName": "Norway"
      },
      {
        "countryKey": "PT",
        "countryName": "Portugal"
      },
      {
        "countryKey": "RO",
        "countryName": "Romania"
      },
      {
        "countryKey": "RS",
        "countryName": "Serbia"
      },
      {
        "countryKey": "SK",
        "countryName": "Slovakia"
      },
      {
        "countryKey": "SI",
        "countryName": "Slovenia"
      },
      {
        "countryKey": "ES",
        "countryName": "Spain"
      },
      {
        "countryKey": "SE",
        "countryName": "Sweden"
      },
      {
        "countryKey": "CH",
        "countryName": "Switzerland"
      },
      {
        "countryKey": "GB",
        "countryName": "United Kingdom"
      },
      {
        "countryKey": "VA",
        "countryName": "Vatican City"
      }
    ]
  },
  {
    "tenantKey": "PARTNER_ACSGR",
    "tomorrowPickUpCutOffTime": "16:00",
    "countryKey": "CY",
    "maxParcelWeightThreshold": "40",
    "countryName": "Cyprus",
    "onboarded": false,
    "validDeliveryCountries": [
      {
        "countryKey": "AD",
        "countryName": "Andorra"
      },
      {
        "countryKey": "AT",
        "countryName": "Austria"
      },
      {
        "countryKey": "BE",
        "countryName": "Belgium"
      },
      {
        "countryKey": "BG",
        "countryName": "Bulgaria"
      },
      {
        "countryKey": "HR",
        "countryName": "Croatia"
      },
      {
        "countryKey": "CZ",
        "countryName": "Czech Republic"
      },
      {
        "countryKey": "DK",
        "countryName": "Denmark"
      },
      {
        "countryKey": "EE",
        "countryName": "Estonia"
      },
      {
        "countryKey": "FI",
        "countryName": "Finland"
      },
      {
        "countryKey": "FR",
        "countryName": "France"
      },
      {
        "countryKey": "DE",
        "countryName": "Germany"
      },
      {
        "countryKey": "GI",
        "countryName": "Gibraltar"
      },
      {
        "countryKey": "GR",
        "countryName": "Greece"
      },
      {
        "countryKey": "HU",
        "countryName": "Hungary"
      },
      {
        "countryKey": "IE",
        "countryName": "Ireland"
      },
      {
        "countryKey": "IT",
        "countryName": "Italy"
      },
      {
        "countryKey": "LV",
        "countryName": "Latvia"
      },
      {
        "countryKey": "LI",
        "countryName": "Liechtenstein"
      },
      {
        "countryKey": "LT",
        "countryName": "Lithuania"
      },
      {
        "countryKey": "LU",
        "countryName": "Luxemburg"
      },
      {
        "countryKey": "MT",
        "countryName": "Malta"
      },
      {
        "countryKey": "MC",
        "countryName": "Monaco"
      },
      {
        "countryKey": "NL",
        "countryName": "Netherlands"
      },
      {
        "countryKey": "NO",
        "countryName": "Norway"
      },
      {
        "countryKey": "PT",
        "countryName": "Portugal"
      },
      {
        "countryKey": "RO",
        "countryName": "Romania"
      },
      {
        "countryKey": "RS",
        "countryName": "Serbia"
      },
      {
        "countryKey": "SK",
        "countryName": "Slovakia"
      },
      {
        "countryKey": "SI",
        "countryName": "Slovenia"
      },
      {
        "countryKey": "ES",
        "countryName": "Spain"
      },
      {
        "countryKey": "SE",
        "countryName": "Sweden"
      },
      {
        "countryKey": "CH",
        "countryName": "Switzerland"
      },
      {
        "countryKey": "GB",
        "countryName": "United Kingdom"
      },
      {
        "countryKey": "VA",
        "countryName": "Vatican City"
      }
    ]
  },
  {
    "tenantKey": "PARTNER_ITELLAEE",
    "tomorrowPickUpCutOffTime": "16:00",
    "countryKey": "EE",
    "maxParcelWeightThreshold": "40",
    "countryName": "Estonia",
    "onboarded": true,
    "validDeliveryCountries": [
      {
        "countryKey": "AD",
        "countryName": "Andorra"
      },
      {
        "countryKey": "AT",
        "countryName": "Austria"
      },
      {
        "countryKey": "BE",
        "countryName": "Belgium"
      },
      {
        "countryKey": "BG",
        "countryName": "Bulgaria"
      },
      {
        "countryKey": "CY",
        "countryName": "Cyprus"
      },
      {
        "countryKey": "CZ",
        "countryName": "Czech Republic"
      },
      {
        "countryKey": "DK",
        "countryName": "Denmark"
      },
      {
        "countryKey": "FI",
        "countryName": "Finland"
      },
      {
        "countryKey": "FR",
        "countryName": "France"
      },
      {
        "countryKey": "DE",
        "countryName": "Germany"
      },
      {
        "countryKey": "GI",
        "countryName": "Gibraltar"
      },
      {
        "countryKey": "GR",
        "countryName": "Greece"
      },
      {
        "countryKey": "HU",
        "countryName": "Hungary"
      },
      {
        "countryKey": "IE",
        "countryName": "Ireland"
      },
      {
        "countryKey": "IT",
        "countryName": "Italy"
      },
      {
        "countryKey": "LV",
        "countryName": "Latvia"
      },
      {
        "countryKey": "LI",
        "countryName": "Liechtenstein"
      },
      {
        "countryKey": "LT",
        "countryName": "Lithuania"
      },
      {
        "countryKey": "LU",
        "countryName": "Luxemburg"
      },
      {
        "countryKey": "MT",
        "countryName": "Malta"
      },
      {
        "countryKey": "MC",
        "countryName": "Monaco"
      },
      {
        "countryKey": "NL",
        "countryName": "Netherlands"
      },
      {
        "countryKey": "NO",
        "countryName": "Norway"
      },
      {
        "countryKey": "PT",
        "countryName": "Portugal"
      },
      {
        "countryKey": "RO",
        "countryName": "Romania"
      },
      {
        "countryKey": "SK",
        "countryName": "Slovakia"
      },
      {
        "countryKey": "SI",
        "countryName": "Slovenia"
      },
      {
        "countryKey": "ES",
        "countryName": "Spain"
      },
      {
        "countryKey": "SE",
        "countryName": "Sweden"
      },
      {
        "countryKey": "CH",
        "countryName": "Switzerland"
      },
      {
        "countryKey": "GB",
        "countryName": "United Kingdom"
      },
      {
        "countryKey": "VA",
        "countryName": "Vatican City"
      }
    ]
  },
  {
    "tenantKey": "PARTNER_PFW",
    "tomorrowPickUpCutOffTime": "16:00",
    "countryKey": "GB",
    "maxParcelWeightThreshold": "40",
    "countryName": "United Kingdom",
    "onboarded": true,
    "validDeliveryCountries": [
      {
        "countryKey": "AD",
        "countryName": "Andorra"
      },
      {
        "countryKey": "AT",
        "countryName": "Austria"
      },
      {
        "countryKey": "BE",
        "countryName": "Belgium"
      },
      {
        "countryKey": "BG",
        "countryName": "Bulgaria"
      },
      {
        "countryKey": "HR",
        "countryName": "Croatia"
      },
      {
        "countryKey": "CY",
        "countryName": "Cyprus"
      },
      {
        "countryKey": "CZ",
        "countryName": "Czech Republic"
      },
      {
        "countryKey": "DK",
        "countryName": "Denmark"
      },
      {
        "countryKey": "EE",
        "countryName": "Estonia"
      },
      {
        "countryKey": "FI",
        "countryName": "Finland"
      },
      {
        "countryKey": "FR",
        "countryName": "France"
      },
      {
        "countryKey": "DE",
        "countryName": "Germany"
      },
      {
        "countryKey": "GI",
        "countryName": "Gibraltar"
      },
      {
        "countryKey": "GR",
        "countryName": "Greece"
      },
      {
        "countryKey": "HU",
        "countryName": "Hungary"
      },
      {
        "countryKey": "IE",
        "countryName": "Ireland"
      },
      {
        "countryKey": "IT",
        "countryName": "Italy"
      },
      {
        "countryKey": "LV",
        "countryName": "Latvia"
      },
      {
        "countryKey": "LI",
        "countryName": "Liechtenstein"
      },
      {
        "countryKey": "LT",
        "countryName": "Lithuania"
      },
      {
        "countryKey": "LU",
        "countryName": "Luxemburg"
      },
      {
        "countryKey": "MT",
        "countryName": "Malta"
      },
      {
        "countryKey": "MC",
        "countryName": "Monaco"
      },
      {
        "countryKey": "NO",
        "countryName": "Norway"
      },
      {
        "countryKey": "PT",
        "countryName": "Portugal"
      },
      {
        "countryKey": "RO",
        "countryName": "Romania"
      },
      {
        "countryKey": "RS",
        "countryName": "Serbia"
      },
      {
        "countryKey": "SK",
        "countryName": "Slovakia"
      },
      {
        "countryKey": "SI",
        "countryName": "Slovenia"
      },
      {
        "countryKey": "ES",
        "countryName": "Spain"
      },
      {
        "countryKey": "SE",
        "countryName": "Sweden"
      },
      {
        "countryKey": "CH",
        "countryName": "Switzerland"
      },
      {
        "countryKey": "VA",
        "countryName": "Vatican City"
      }
    ]
  },
  {
    "tenantKey": "PARTNER_ITELLALT",
    "tomorrowPickUpCutOffTime": "16:00",
    "countryKey": "LT",
    "maxParcelWeightThreshold": "40",
    "countryName": "Lithuania",
    "onboarded": true,
    "validDeliveryCountries": [
      {
        "countryKey": "AD",
        "countryName": "Andorra"
      },
      {
        "countryKey": "AT",
        "countryName": "Austria"
      },
      {
        "countryKey": "BE",
        "countryName": "Belgium"
      },
      {
        "countryKey": "BG",
        "countryName": "Bulgaria"
      },
      {
        "countryKey": "HR",
        "countryName": "Croatia"
      },
      {
        "countryKey": "CY",
        "countryName": "Cyprus"
      },
      {
        "countryKey": "CZ",
        "countryName": "Czech Republic"
      },
      {
        "countryKey": "DK",
        "countryName": "Denmark"
      },
      {
        "countryKey": "EE",
        "countryName": "Estonia"
      },
      {
        "countryKey": "FI",
        "countryName": "Finland"
      },
      {
        "countryKey": "FR",
        "countryName": "France"
      },
      {
        "countryKey": "DE",
        "countryName": "Germany"
      },
      {
        "countryKey": "GI",
        "countryName": "Gibraltar"
      },
      {
        "countryKey": "GR",
        "countryName": "Greece"
      },
      {
        "countryKey": "HU",
        "countryName": "Hungary"
      },
      {
        "countryKey": "IE",
        "countryName": "Ireland"
      },
      {
        "countryKey": "IT",
        "countryName": "Italy"
      },
      {
        "countryKey": "LV",
        "countryName": "Latvia"
      },
      {
        "countryKey": "LI",
        "countryName": "Liechtenstein"
      },
      {
        "countryKey": "LU",
        "countryName": "Luxemburg"
      },
      {
        "countryKey": "MT",
        "countryName": "Malta"
      },
      {
        "countryKey": "MC",
        "countryName": "Monaco"
      },
      {
        "countryKey": "NL",
        "countryName": "Netherlands"
      },
      {
        "countryKey": "NO",
        "countryName": "Norway"
      },
      {
        "countryKey": "PT",
        "countryName": "Portugal"
      },
      {
        "countryKey": "RO",
        "countryName": "Romania"
      },
      {
        "countryKey": "RS",
        "countryName": "Serbia"
      },
      {
        "countryKey": "SK",
        "countryName": "Slovakia"
      },
      {
        "countryKey": "SI",
        "countryName": "Slovenia"
      },
      {
        "countryKey": "ES",
        "countryName": "Spain"
      },
      {
        "countryKey": "SE",
        "countryName": "Sweden"
      },
      {
        "countryKey": "CH",
        "countryName": "Switzerland"
      },
      {
        "countryKey": "GB",
        "countryName": "United Kingdom"
      },
      {
        "countryKey": "VA",
        "countryName": "Vatican City"
      }
    ]
  },
  {
    "tenantKey": "PARTNER_SCHENKERSE",
    "tomorrowPickUpCutOffTime": "16:00",
    "countryKey": "SE",
    "maxParcelWeightThreshold": "40",
    "countryName": "Sweden",
    "onboarded": true,
    "validDeliveryCountries": [
      {
        "countryKey": "AD",
        "countryName": "Andorra"
      },
      {
        "countryKey": "AT",
        "countryName": "Austria"
      },
      {
        "countryKey": "BE",
        "countryName": "Belgium"
      },
      {
        "countryKey": "BG",
        "countryName": "Bulgaria"
      },
      {
        "countryKey": "HR",
        "countryName": "Croatia"
      },
      {
        "countryKey": "CY",
        "countryName": "Cyprus"
      },
      {
        "countryKey": "CZ",
        "countryName": "Czech Republic"
      },
      {
        "countryKey": "DK",
        "countryName": "Denmark"
      },
      {
        "countryKey": "EE",
        "countryName": "Estonia"
      },
      {
        "countryKey": "FI",
        "countryName": "Finland"
      },
      {
        "countryKey": "FR",
        "countryName": "France"
      },
      {
        "countryKey": "DE",
        "countryName": "Germany"
      },
      {
        "countryKey": "GI",
        "countryName": "Gibraltar"
      },
      {
        "countryKey": "GR",
        "countryName": "Greece"
      },
      {
        "countryKey": "HU",
        "countryName": "Hungary"
      },
      {
        "countryKey": "IE",
        "countryName": "Ireland"
      },
      {
        "countryKey": "IT",
        "countryName": "Italy"
      },
      {
        "countryKey": "LV",
        "countryName": "Latvia"
      },
      {
        "countryKey": "LI",
        "countryName": "Liechtenstein"
      },
      {
        "countryKey": "LT",
        "countryName": "Lithuania"
      },
      {
        "countryKey": "LU",
        "countryName": "Luxemburg"
      },
      {
        "countryKey": "MT",
        "countryName": "Malta"
      },
      {
        "countryKey": "MC",
        "countryName": "Monaco"
      },
      {
        "countryKey": "NL",
        "countryName": "Netherlands"
      },
      {
        "countryKey": "NO",
        "countryName": "Norway"
      },
      {
        "countryKey": "PT",
        "countryName": "Portugal"
      },
      {
        "countryKey": "RO",
        "countryName": "Romania"
      },
      {
        "countryKey": "RS",
        "countryName": "Serbia"
      },
      {
        "countryKey": "SK",
        "countryName": "Slovakia"
      },
      {
        "countryKey": "SI",
        "countryName": "Slovenia"
      },
      {
        "countryKey": "ES",
        "countryName": "Spain"
      },
      {
        "countryKey": "CH",
        "countryName": "Switzerland"
      },
      {
        "countryKey": "GB",
        "countryName": "United Kingdom"
      },
      {
        "countryKey": "VA",
        "countryName": "Vatican City"
      }
    ]
  },
  {
    "tenantKey": "GLS_IE",
    "tomorrowPickUpCutOffTime": "23:00",
    "countryKey": "IE",
    "maxParcelWeightThreshold": "40",
    "countryName": "Ireland",
    "onboarded": false,
    "validDeliveryCountries": [
      {
        "countryKey": "AD",
        "countryName": "Andorra"
      },
      {
        "countryKey": "AT",
        "countryName": "Austria"
      },
      {
        "countryKey": "BE",
        "countryName": "Belgium"
      },
      {
        "countryKey": "BG",
        "countryName": "Bulgaria"
      },
      {
        "countryKey": "HR",
        "countryName": "Croatia"
      },
      {
        "countryKey": "CY",
        "countryName": "Cyprus"
      },
      {
        "countryKey": "CZ",
        "countryName": "Czech Republic"
      },
      {
        "countryKey": "DK",
        "countryName": "Denmark"
      },
      {
        "countryKey": "EE",
        "countryName": "Estonia"
      },
      {
        "countryKey": "FI",
        "countryName": "Finland"
      },
      {
        "countryKey": "FR",
        "countryName": "France"
      },
      {
        "countryKey": "DE",
        "countryName": "Germany"
      },
      {
        "countryKey": "GI",
        "countryName": "Gibraltar"
      },
      {
        "countryKey": "GR",
        "countryName": "Greece"
      },
      {
        "countryKey": "HU",
        "countryName": "Hungary"
      },
      {
        "countryKey": "IT",
        "countryName": "Italy"
      },
      {
        "countryKey": "LV",
        "countryName": "Latvia"
      },
      {
        "countryKey": "LI",
        "countryName": "Liechtenstein"
      },
      {
        "countryKey": "LT",
        "countryName": "Lithuania"
      },
      {
        "countryKey": "LU",
        "countryName": "Luxemburg"
      },
      {
        "countryKey": "MT",
        "countryName": "Malta"
      },
      {
        "countryKey": "MC",
        "countryName": "Monaco"
      },
      {
        "countryKey": "NL",
        "countryName": "Netherlands"
      },
      {
        "countryKey": "NO",
        "countryName": "Norway"
      },
      {
        "countryKey": "PT",
        "countryName": "Portugal"
      },
      {
        "countryKey": "RO",
        "countryName": "Romania"
      },
      {
        "countryKey": "RS",
        "countryName": "Serbia"
      },
      {
        "countryKey": "SK",
        "countryName": "Slovakia"
      },
      {
        "countryKey": "SI",
        "countryName": "Slovenia"
      },
      {
        "countryKey": "ES",
        "countryName": "Spain"
      },
      {
        "countryKey": "SE",
        "countryName": "Sweden"
      },
      {
        "countryKey": "CH",
        "countryName": "Switzerland"
      },
      {
        "countryKey": "GB",
        "countryName": "United Kingdom"
      },
      {
        "countryKey": "VA",
        "countryName": "Vatican City"
      }
    ]
  },
  {
    "tenantKey": "GLS_RS",
    "tomorrowPickUpCutOffTime": "16:00",
    "countryKey": "RS",
    "maxParcelWeightThreshold": "40",
    "countryName": "Serbia",
    "onboarded": true,
    "validDeliveryCountries": [
      {
        "countryKey": "AD",
        "countryName": "Andorra"
      },
      {
        "countryKey": "AT",
        "countryName": "Austria"
      },
      {
        "countryKey": "BE",
        "countryName": "Belgium"
      },
      {
        "countryKey": "BG",
        "countryName": "Bulgaria"
      },
      {
        "countryKey": "HR",
        "countryName": "Croatia"
      },
      {
        "countryKey": "CY",
        "countryName": "Cyprus"
      },
      {
        "countryKey": "CZ",
        "countryName": "Czech Republic"
      },
      {
        "countryKey": "DK",
        "countryName": "Denmark"
      },
      {
        "countryKey": "EE",
        "countryName": "Estonia"
      },
      {
        "countryKey": "FI",
        "countryName": "Finland"
      },
      {
        "countryKey": "FR",
        "countryName": "France"
      },
      {
        "countryKey": "DE",
        "countryName": "Germany"
      },
      {
        "countryKey": "GI",
        "countryName": "Gibraltar"
      },
      {
        "countryKey": "GR",
        "countryName": "Greece"
      },
      {
        "countryKey": "HU",
        "countryName": "Hungary"
      },
      {
        "countryKey": "IE",
        "countryName": "Ireland"
      },
      {
        "countryKey": "IT",
        "countryName": "Italy"
      },
      {
        "countryKey": "LV",
        "countryName": "Latvia"
      },
      {
        "countryKey": "LI",
        "countryName": "Liechtenstein"
      },
      {
        "countryKey": "LT",
        "countryName": "Lithuania"
      },
      {
        "countryKey": "LU",
        "countryName": "Luxemburg"
      },
      {
        "countryKey": "MT",
        "countryName": "Malta"
      },
      {
        "countryKey": "MC",
        "countryName": "Monaco"
      },
      {
        "countryKey": "NL",
        "countryName": "Netherlands"
      },
      {
        "countryKey": "NO",
        "countryName": "Norway"
      },
      {
        "countryKey": "PT",
        "countryName": "Portugal"
      },
      {
        "countryKey": "RO",
        "countryName": "Romania"
      },
      {
        "countryKey": "SK",
        "countryName": "Slovakia"
      },
      {
        "countryKey": "SI",
        "countryName": "Slovenia"
      },
      {
        "countryKey": "ES",
        "countryName": "Spain"
      },
      {
        "countryKey": "SE",
        "countryName": "Sweden"
      },
      {
        "countryKey": "CH",
        "countryName": "Switzerland"
      },
      {
        "countryKey": "GB",
        "countryName": "United Kingdom"
      },
      {
        "countryKey": "VA",
        "countryName": "Vatican City"
      }
    ]
  },
  {
    "tenantKey": "GLS_SK",
    "tomorrowPickUpCutOffTime": "16:00",
    "countryKey": "SK",
    "maxParcelWeightThreshold": "40",
    "countryName": "Slovakia",
    "onboarded": true,
    "validDeliveryCountries": [
      {
        "countryKey": "AD",
        "countryName": "Andorra"
      },
      {
        "countryKey": "AT",
        "countryName": "Austria"
      },
      {
        "countryKey": "BE",
        "countryName": "Belgium"
      },
      {
        "countryKey": "BG",
        "countryName": "Bulgaria"
      },
      {
        "countryKey": "HR",
        "countryName": "Croatia"
      },
      {
        "countryKey": "CY",
        "countryName": "Cyprus"
      },
      {
        "countryKey": "CZ",
        "countryName": "Czech Republic"
      },
      {
        "countryKey": "DK",
        "countryName": "Denmark"
      },
      {
        "countryKey": "EE",
        "countryName": "Estonia"
      },
      {
        "countryKey": "FI",
        "countryName": "Finland"
      },
      {
        "countryKey": "FR",
        "countryName": "France"
      },
      {
        "countryKey": "DE",
        "countryName": "Germany"
      },
      {
        "countryKey": "GI",
        "countryName": "Gibraltar"
      },
      {
        "countryKey": "GR",
        "countryName": "Greece"
      },
      {
        "countryKey": "HU",
        "countryName": "Hungary"
      },
      {
        "countryKey": "IE",
        "countryName": "Ireland"
      },
      {
        "countryKey": "IT",
        "countryName": "Italy"
      },
      {
        "countryKey": "LV",
        "countryName": "Latvia"
      },
      {
        "countryKey": "LI",
        "countryName": "Liechtenstein"
      },
      {
        "countryKey": "LT",
        "countryName": "Lithuania"
      },
      {
        "countryKey": "LU",
        "countryName": "Luxemburg"
      },
      {
        "countryKey": "MT",
        "countryName": "Malta"
      },
      {
        "countryKey": "MC",
        "countryName": "Monaco"
      },
      {
        "countryKey": "NL",
        "countryName": "Netherlands"
      },
      {
        "countryKey": "NO",
        "countryName": "Norway"
      },
      {
        "countryKey": "PT",
        "countryName": "Portugal"
      },
      {
        "countryKey": "RO",
        "countryName": "Romania"
      },
      {
        "countryKey": "RS",
        "countryName": "Serbia"
      },
      {
        "countryKey": "SI",
        "countryName": "Slovenia"
      },
      {
        "countryKey": "ES",
        "countryName": "Spain"
      },
      {
        "countryKey": "SE",
        "countryName": "Sweden"
      },
      {
        "countryKey": "CH",
        "countryName": "Switzerland"
      },
      {
        "countryKey": "GB",
        "countryName": "United Kingdom"
      },
      {
        "countryKey": "VA",
        "countryName": "Vatican City"
      }
    ]
  },
  {
    "tenantKey": "GLS_SI",
    "tomorrowPickUpCutOffTime": "16:00",
    "countryKey": "SI",
    "maxParcelWeightThreshold": "40",
    "countryName": "Slovenia",
    "onboarded": true,
    "validDeliveryCountries": [
      {
        "countryKey": "AD",
        "countryName": "Andorra"
      },
      {
        "countryKey": "AT",
        "countryName": "Austria"
      },
      {
        "countryKey": "BE",
        "countryName": "Belgium"
      },
      {
        "countryKey": "BG",
        "countryName": "Bulgaria"
      },
      {
        "countryKey": "HR",
        "countryName": "Croatia"
      },
      {
        "countryKey": "CY",
        "countryName": "Cyprus"
      },
      {
        "countryKey": "CZ",
        "countryName": "Czech Republic"
      },
      {
        "countryKey": "DK",
        "countryName": "Denmark"
      },
      {
        "countryKey": "EE",
        "countryName": "Estonia"
      },
      {
        "countryKey": "FI",
        "countryName": "Finland"
      },
      {
        "countryKey": "FR",
        "countryName": "France"
      },
      {
        "countryKey": "DE",
        "countryName": "Germany"
      },
      {
        "countryKey": "GI",
        "countryName": "Gibraltar"
      },
      {
        "countryKey": "GR",
        "countryName": "Greece"
      },
      {
        "countryKey": "HU",
        "countryName": "Hungary"
      },
      {
        "countryKey": "IE",
        "countryName": "Ireland"
      },
      {
        "countryKey": "IT",
        "countryName": "Italy"
      },
      {
        "countryKey": "LV",
        "countryName": "Latvia"
      },
      {
        "countryKey": "LI",
        "countryName": "Liechtenstein"
      },
      {
        "countryKey": "LT",
        "countryName": "Lithuania"
      },
      {
        "countryKey": "LU",
        "countryName": "Luxemburg"
      },
      {
        "countryKey": "MT",
        "countryName": "Malta"
      },
      {
        "countryKey": "MC",
        "countryName": "Monaco"
      },
      {
        "countryKey": "NL",
        "countryName": "Netherlands"
      },
      {
        "countryKey": "NO",
        "countryName": "Norway"
      },
      {
        "countryKey": "PT",
        "countryName": "Portugal"
      },
      {
        "countryKey": "RO",
        "countryName": "Romania"
      },
      {
        "countryKey": "RS",
        "countryName": "Serbia"
      },
      {
        "countryKey": "SK",
        "countryName": "Slovakia"
      },
      {
        "countryKey": "ES",
        "countryName": "Spain"
      },
      {
        "countryKey": "SE",
        "countryName": "Sweden"
      },
      {
        "countryKey": "CH",
        "countryName": "Switzerland"
      },
      {
        "countryKey": "GB",
        "countryName": "United Kingdom"
      },
      {
        "countryKey": "VA",
        "countryName": "Vatican City"
      }
    ]
  },
  {
    "tenantKey": "PARTNER_ITELLALV",
    "tomorrowPickUpCutOffTime": "16:00",
    "countryKey": "LV",
    "maxParcelWeightThreshold": "40",
    "countryName": "Latvia",
    "onboarded": true,
    "validDeliveryCountries": [
      {
        "countryKey": "AD",
        "countryName": "Andorra"
      },
      {
        "countryKey": "AT",
        "countryName": "Austria"
      },
      {
        "countryKey": "BE",
        "countryName": "Belgium"
      },
      {
        "countryKey": "BG",
        "countryName": "Bulgaria"
      },
      {
        "countryKey": "HR",
        "countryName": "Croatia"
      },
      {
        "countryKey": "CY",
        "countryName": "Cyprus"
      },
      {
        "countryKey": "CZ",
        "countryName": "Czech Republic"
      },
      {
        "countryKey": "DK",
        "countryName": "Denmark"
      },
      {
        "countryKey": "EE",
        "countryName": "Estonia"
      },
      {
        "countryKey": "FI",
        "countryName": "Finland"
      },
      {
        "countryKey": "FR",
        "countryName": "France"
      },
      {
        "countryKey": "DE",
        "countryName": "Germany"
      },
      {
        "countryKey": "GI",
        "countryName": "Gibraltar"
      },
      {
        "countryKey": "GR",
        "countryName": "Greece"
      },
      {
        "countryKey": "HU",
        "countryName": "Hungary"
      },
      {
        "countryKey": "IE",
        "countryName": "Ireland"
      },
      {
        "countryKey": "IT",
        "countryName": "Italy"
      },
      {
        "countryKey": "LI",
        "countryName": "Liechtenstein"
      },
      {
        "countryKey": "LT",
        "countryName": "Lithuania"
      },
      {
        "countryKey": "LU",
        "countryName": "Luxemburg"
      },
      {
        "countryKey": "MT",
        "countryName": "Malta"
      },
      {
        "countryKey": "MC",
        "countryName": "Monaco"
      },
      {
        "countryKey": "NL",
        "countryName": "Netherlands"
      },
      {
        "countryKey": "NO",
        "countryName": "Norway"
      },
      {
        "countryKey": "PT",
        "countryName": "Portugal"
      },
      {
        "countryKey": "RO",
        "countryName": "Romania"
      },
      {
        "countryKey": "RS",
        "countryName": "Serbia"
      },
      {
        "countryKey": "SK",
        "countryName": "Slovakia"
      },
      {
        "countryKey": "SI",
        "countryName": "Slovenia"
      },
      {
        "countryKey": "ES",
        "countryName": "Spain"
      },
      {
        "countryKey": "SE",
        "countryName": "Sweden"
      },
      {
        "countryKey": "CH",
        "countryName": "Switzerland"
      },
      {
        "countryKey": "GB",
        "countryName": "United Kingdom"
      },
      {
        "countryKey": "VA",
        "countryName": "Vatican City"
      }
    ]
  },
  {
    "tenantKey": "GLS_HU",
    "tomorrowPickUpCutOffTime": "16:00",
    "countryKey": "HU",
    "maxParcelWeightThreshold": "40",
    "countryName": "Hungary",
    "onboarded": true,
    "validDeliveryCountries": [
      {
        "countryKey": "AD",
        "countryName": "Andorra"
      },
      {
        "countryKey": "AT",
        "countryName": "Austria"
      },
      {
        "countryKey": "BE",
        "countryName": "Belgium"
      },
      {
        "countryKey": "BG",
        "countryName": "Bulgaria"
      },
      {
        "countryKey": "HR",
        "countryName": "Croatia"
      },
      {
        "countryKey": "CY",
        "countryName": "Cyprus"
      },
      {
        "countryKey": "CZ",
        "countryName": "Czech Republic"
      },
      {
        "countryKey": "DK",
        "countryName": "Denmark"
      },
      {
        "countryKey": "EE",
        "countryName": "Estonia"
      },
      {
        "countryKey": "FI",
        "countryName": "Finland"
      },
      {
        "countryKey": "FR",
        "countryName": "France"
      },
      {
        "countryKey": "DE",
        "countryName": "Germany"
      },
      {
        "countryKey": "GI",
        "countryName": "Gibraltar"
      },
      {
        "countryKey": "GR",
        "countryName": "Greece"
      },
      {
        "countryKey": "IE",
        "countryName": "Ireland"
      },
      {
        "countryKey": "IT",
        "countryName": "Italy"
      },
      {
        "countryKey": "LV",
        "countryName": "Latvia"
      },
      {
        "countryKey": "LI",
        "countryName": "Liechtenstein"
      },
      {
        "countryKey": "LT",
        "countryName": "Lithuania"
      },
      {
        "countryKey": "LU",
        "countryName": "Luxemburg"
      },
      {
        "countryKey": "MT",
        "countryName": "Malta"
      },
      {
        "countryKey": "MC",
        "countryName": "Monaco"
      },
      {
        "countryKey": "NL",
        "countryName": "Netherlands"
      },
      {
        "countryKey": "NO",
        "countryName": "Norway"
      },
      {
        "countryKey": "PT",
        "countryName": "Portugal"
      },
      {
        "countryKey": "RO",
        "countryName": "Romania"
      },
      {
        "countryKey": "RS",
        "countryName": "Serbia"
      },
      {
        "countryKey": "SK",
        "countryName": "Slovakia"
      },
      {
        "countryKey": "SI",
        "countryName": "Slovenia"
      },
      {
        "countryKey": "ES",
        "countryName": "Spain"
      },
      {
        "countryKey": "SE",
        "countryName": "Sweden"
      },
      {
        "countryKey": "CH",
        "countryName": "Switzerland"
      },
      {
        "countryKey": "GB",
        "countryName": "United Kingdom"
      },
      {
        "countryKey": "VA",
        "countryName": "Vatican City"
      }
    ]
  },
  {
    "tenantKey": "GLS_FR",
    "tomorrowPickUpCutOffTime": "16:00",
    "countryKey": "FR",
    "maxParcelWeightThreshold": "40",
    "countryName": "France",
    "onboarded": false,
    "validDeliveryCountries": [
      {
        "countryKey": "AD",
        "countryName": "Andorra"
      },
      {
        "countryKey": "AT",
        "countryName": "Austria"
      },
      {
        "countryKey": "BE",
        "countryName": "Belgium"
      },
      {
        "countryKey": "BG",
        "countryName": "Bulgaria"
      },
      {
        "countryKey": "HR",
        "countryName": "Croatia"
      },
      {
        "countryKey": "CY",
        "countryName": "Cyprus"
      },
      {
        "countryKey": "CZ",
        "countryName": "Czech Republic"
      },
      {
        "countryKey": "DK",
        "countryName": "Denmark"
      },
      {
        "countryKey": "EE",
        "countryName": "Estonia"
      },
      {
        "countryKey": "FI",
        "countryName": "Finland"
      },
      {
        "countryKey": "DE",
        "countryName": "Germany"
      },
      {
        "countryKey": "GI",
        "countryName": "Gibraltar"
      },
      {
        "countryKey": "GR",
        "countryName": "Greece"
      },
      {
        "countryKey": "HU",
        "countryName": "Hungary"
      },
      {
        "countryKey": "IE",
        "countryName": "Ireland"
      },
      {
        "countryKey": "IT",
        "countryName": "Italy"
      },
      {
        "countryKey": "LV",
        "countryName": "Latvia"
      },
      {
        "countryKey": "LI",
        "countryName": "Liechtenstein"
      },
      {
        "countryKey": "LT",
        "countryName": "Lithuania"
      },
      {
        "countryKey": "LU",
        "countryName": "Luxemburg"
      },
      {
        "countryKey": "MT",
        "countryName": "Malta"
      },
      {
        "countryKey": "MC",
        "countryName": "Monaco"
      },
      {
        "countryKey": "NL",
        "countryName": "Netherlands"
      },
      {
        "countryKey": "NO",
        "countryName": "Norway"
      },
      {
        "countryKey": "PT",
        "countryName": "Portugal"
      },
      {
        "countryKey": "RO",
        "countryName": "Romania"
      },
      {
        "countryKey": "RS",
        "countryName": "Serbia"
      },
      {
        "countryKey": "SK",
        "countryName": "Slovakia"
      },
      {
        "countryKey": "SI",
        "countryName": "Slovenia"
      },
      {
        "countryKey": "ES",
        "countryName": "Spain"
      },
      {
        "countryKey": "SE",
        "countryName": "Sweden"
      },
      {
        "countryKey": "CH",
        "countryName": "Switzerland"
      },
      {
        "countryKey": "GB",
        "countryName": "United Kingdom"
      },
      {
        "countryKey": "VA",
        "countryName": "Vatican City"
      }
    ]
  },
  {
    "tenantKey": "GLS_LU",
    "tomorrowPickUpCutOffTime": "23:00",
    "countryKey": "LU",
    "maxParcelWeightThreshold": "40",
    "countryName": "Luxemburg",
    "onboarded": false,
    "validDeliveryCountries": [
      {
        "countryKey": "AD",
        "countryName": "Andorra"
      },
      {
        "countryKey": "AT",
        "countryName": "Austria"
      },
      {
        "countryKey": "BE",
        "countryName": "Belgium"
      },
      {
        "countryKey": "BG",
        "countryName": "Bulgaria"
      },
      {
        "countryKey": "HR",
        "countryName": "Croatia"
      },
      {
        "countryKey": "CY",
        "countryName": "Cyprus"
      },
      {
        "countryKey": "CZ",
        "countryName": "Czech Republic"
      },
      {
        "countryKey": "DK",
        "countryName": "Denmark"
      },
      {
        "countryKey": "EE",
        "countryName": "Estonia"
      },
      {
        "countryKey": "FI",
        "countryName": "Finland"
      },
      {
        "countryKey": "FR",
        "countryName": "France"
      },
      {
        "countryKey": "DE",
        "countryName": "Germany"
      },
      {
        "countryKey": "GI",
        "countryName": "Gibraltar"
      },
      {
        "countryKey": "GR",
        "countryName": "Greece"
      },
      {
        "countryKey": "HU",
        "countryName": "Hungary"
      },
      {
        "countryKey": "IE",
        "countryName": "Ireland"
      },
      {
        "countryKey": "IT",
        "countryName": "Italy"
      },
      {
        "countryKey": "LV",
        "countryName": "Latvia"
      },
      {
        "countryKey": "LI",
        "countryName": "Liechtenstein"
      },
      {
        "countryKey": "LT",
        "countryName": "Lithuania"
      },
      {
        "countryKey": "MT",
        "countryName": "Malta"
      },
      {
        "countryKey": "MC",
        "countryName": "Monaco"
      },
      {
        "countryKey": "NL",
        "countryName": "Netherlands"
      },
      {
        "countryKey": "NO",
        "countryName": "Norway"
      },
      {
        "countryKey": "PT",
        "countryName": "Portugal"
      },
      {
        "countryKey": "RO",
        "countryName": "Romania"
      },
      {
        "countryKey": "RS",
        "countryName": "Serbia"
      },
      {
        "countryKey": "SK",
        "countryName": "Slovakia"
      },
      {
        "countryKey": "SI",
        "countryName": "Slovenia"
      },
      {
        "countryKey": "ES",
        "countryName": "Spain"
      },
      {
        "countryKey": "SE",
        "countryName": "Sweden"
      },
      {
        "countryKey": "CH",
        "countryName": "Switzerland"
      },
      {
        "countryKey": "GB",
        "countryName": "United Kingdom"
      },
      {
        "countryKey": "VA",
        "countryName": "Vatican City"
      }
    ]
  },
  {
    "tenantKey": "GLS_HR",
    "tomorrowPickUpCutOffTime": "16:00",
    "countryKey": "HR",
    "maxParcelWeightThreshold": "40",
    "countryName": "Croatia",
    "onboarded": true,
    "validDeliveryCountries": [
      {
        "countryKey": "AD",
        "countryName": "Andorra"
      },
      {
        "countryKey": "AT",
        "countryName": "Austria"
      },
      {
        "countryKey": "BE",
        "countryName": "Belgium"
      },
      {
        "countryKey": "BG",
        "countryName": "Bulgaria"
      },
      {
        "countryKey": "CY",
        "countryName": "Cyprus"
      },
      {
        "countryKey": "CZ",
        "countryName": "Czech Republic"
      },
      {
        "countryKey": "DK",
        "countryName": "Denmark"
      },
      {
        "countryKey": "EE",
        "countryName": "Estonia"
      },
      {
        "countryKey": "FI",
        "countryName": "Finland"
      },
      {
        "countryKey": "FR",
        "countryName": "France"
      },
      {
        "countryKey": "DE",
        "countryName": "Germany"
      },
      {
        "countryKey": "GI",
        "countryName": "Gibraltar"
      },
      {
        "countryKey": "GR",
        "countryName": "Greece"
      },
      {
        "countryKey": "HU",
        "countryName": "Hungary"
      },
      {
        "countryKey": "IE",
        "countryName": "Ireland"
      },
      {
        "countryKey": "IT",
        "countryName": "Italy"
      },
      {
        "countryKey": "LV",
        "countryName": "Latvia"
      },
      {
        "countryKey": "LI",
        "countryName": "Liechtenstein"
      },
      {
        "countryKey": "LT",
        "countryName": "Lithuania"
      },
      {
        "countryKey": "LU",
        "countryName": "Luxemburg"
      },
      {
        "countryKey": "MT",
        "countryName": "Malta"
      },
      {
        "countryKey": "MC",
        "countryName": "Monaco"
      },
      {
        "countryKey": "NL",
        "countryName": "Netherlands"
      },
      {
        "countryKey": "NO",
        "countryName": "Norway"
      },
      {
        "countryKey": "PT",
        "countryName": "Portugal"
      },
      {
        "countryKey": "RO",
        "countryName": "Romania"
      },
      {
        "countryKey": "RS",
        "countryName": "Serbia"
      },
      {
        "countryKey": "SK",
        "countryName": "Slovakia"
      },
      {
        "countryKey": "SI",
        "countryName": "Slovenia"
      },
      {
        "countryKey": "ES",
        "countryName": "Spain"
      },
      {
        "countryKey": "SE",
        "countryName": "Sweden"
      },
      {
        "countryKey": "CH",
        "countryName": "Switzerland"
      },
      {
        "countryKey": "GB",
        "countryName": "United Kingdom"
      },
      {
        "countryKey": "VA",
        "countryName": "Vatican City"
      }
    ]
  },
  {
    "tenantKey": "GLS_DK",
    "tomorrowPickUpCutOffTime": "23:00",
    "countryKey": "DK",
    "maxParcelWeightThreshold": "40",
    "countryName": "Denmark",
    "onboarded": true,
    "validDeliveryCountries": [
      {
        "countryKey": "AD",
        "countryName": "Andorra"
      },
      {
        "countryKey": "AT",
        "countryName": "Austria"
      },
      {
        "countryKey": "BE",
        "countryName": "Belgium"
      },
      {
        "countryKey": "BG",
        "countryName": "Bulgaria"
      },
      {
        "countryKey": "HR",
        "countryName": "Croatia"
      },
      {
        "countryKey": "CY",
        "countryName": "Cyprus"
      },
      {
        "countryKey": "CZ",
        "countryName": "Czech Republic"
      },
      {
        "countryKey": "EE",
        "countryName": "Estonia"
      },
      {
        "countryKey": "FI",
        "countryName": "Finland"
      },
      {
        "countryKey": "FR",
        "countryName": "France"
      },
      {
        "countryKey": "DE",
        "countryName": "Germany"
      },
      {
        "countryKey": "GI",
        "countryName": "Gibraltar"
      },
      {
        "countryKey": "GR",
        "countryName": "Greece"
      },
      {
        "countryKey": "HU",
        "countryName": "Hungary"
      },
      {
        "countryKey": "IE",
        "countryName": "Ireland"
      },
      {
        "countryKey": "IT",
        "countryName": "Italy"
      },
      {
        "countryKey": "LV",
        "countryName": "Latvia"
      },
      {
        "countryKey": "LI",
        "countryName": "Liechtenstein"
      },
      {
        "countryKey": "LT",
        "countryName": "Lithuania"
      },
      {
        "countryKey": "LU",
        "countryName": "Luxemburg"
      },
      {
        "countryKey": "MT",
        "countryName": "Malta"
      },
      {
        "countryKey": "MC",
        "countryName": "Monaco"
      },
      {
        "countryKey": "NL",
        "countryName": "Netherlands"
      },
      {
        "countryKey": "PT",
        "countryName": "Portugal"
      },
      {
        "countryKey": "RO",
        "countryName": "Romania"
      },
      {
        "countryKey": "RS",
        "countryName": "Serbia"
      },
      {
        "countryKey": "SK",
        "countryName": "Slovakia"
      },
      {
        "countryKey": "SI",
        "countryName": "Slovenia"
      },
      {
        "countryKey": "ES",
        "countryName": "Spain"
      },
      {
        "countryKey": "SE",
        "countryName": "Sweden"
      },
      {
        "countryKey": "GB",
        "countryName": "United Kingdom"
      },
      {
        "countryKey": "VA",
        "countryName": "Vatican City"
      }
    ]
  },
  {
    "tenantKey": "PARTNER_SWISS",
    "tomorrowPickUpCutOffTime": "16:00",
    "countryKey": "CH",
    "maxParcelWeightThreshold": "40",
    "countryName": "Switzerland",
    "onboarded": true,
    "validDeliveryCountries": [
      {
        "countryKey": "AD",
        "countryName": "Andorra"
      },
      {
        "countryKey": "AT",
        "countryName": "Austria"
      },
      {
        "countryKey": "BE",
        "countryName": "Belgium"
      },
      {
        "countryKey": "BG",
        "countryName": "Bulgaria"
      },
      {
        "countryKey": "HR",
        "countryName": "Croatia"
      },
      {
        "countryKey": "CY",
        "countryName": "Cyprus"
      },
      {
        "countryKey": "CZ",
        "countryName": "Czech Republic"
      },
      {
        "countryKey": "DK",
        "countryName": "Denmark"
      },
      {
        "countryKey": "EE",
        "countryName": "Estonia"
      },
      {
        "countryKey": "FI",
        "countryName": "Finland"
      },
      {
        "countryKey": "FR",
        "countryName": "France"
      },
      {
        "countryKey": "DE",
        "countryName": "Germany"
      },
      {
        "countryKey": "GI",
        "countryName": "Gibraltar"
      },
      {
        "countryKey": "GR",
        "countryName": "Greece"
      },
      {
        "countryKey": "HU",
        "countryName": "Hungary"
      },
      {
        "countryKey": "IE",
        "countryName": "Ireland"
      },
      {
        "countryKey": "IT",
        "countryName": "Italy"
      },
      {
        "countryKey": "LV",
        "countryName": "Latvia"
      },
      {
        "countryKey": "LI",
        "countryName": "Liechtenstein"
      },
      {
        "countryKey": "LT",
        "countryName": "Lithuania"
      },
      {
        "countryKey": "LU",
        "countryName": "Luxemburg"
      },
      {
        "countryKey": "MT",
        "countryName": "Malta"
      },
      {
        "countryKey": "MC",
        "countryName": "Monaco"
      },
      {
        "countryKey": "NL",
        "countryName": "Netherlands"
      },
      {
        "countryKey": "NO",
        "countryName": "Norway"
      },
      {
        "countryKey": "PT",
        "countryName": "Portugal"
      },
      {
        "countryKey": "RO",
        "countryName": "Romania"
      },
      {
        "countryKey": "RS",
        "countryName": "Serbia"
      },
      {
        "countryKey": "SK",
        "countryName": "Slovakia"
      },
      {
        "countryKey": "SI",
        "countryName": "Slovenia"
      },
      {
        "countryKey": "ES",
        "countryName": "Spain"
      },
      {
        "countryKey": "SE",
        "countryName": "Sweden"
      },
      {
        "countryKey": "GB",
        "countryName": "United Kingdom"
      },
      {
        "countryKey": "VA",
        "countryName": "Vatican City"
      }
    ]
  },
  {
    "tenantKey": "PARTNER_INTERLGBG",
    "tomorrowPickUpCutOffTime": "16:00",
    "countryKey": "BG",
    "maxParcelWeightThreshold": "40",
    "countryName": "Bulgaria",
    "onboarded": true,
    "validDeliveryCountries": [
      {
        "countryKey": "AD",
        "countryName": "Andorra"
      },
      {
        "countryKey": "AT",
        "countryName": "Austria"
      },
      {
        "countryKey": "BE",
        "countryName": "Belgium"
      },
      {
        "countryKey": "HR",
        "countryName": "Croatia"
      },
      {
        "countryKey": "CY",
        "countryName": "Cyprus"
      },
      {
        "countryKey": "CZ",
        "countryName": "Czech Republic"
      },
      {
        "countryKey": "DK",
        "countryName": "Denmark"
      },
      {
        "countryKey": "EE",
        "countryName": "Estonia"
      },
      {
        "countryKey": "FI",
        "countryName": "Finland"
      },
      {
        "countryKey": "FR",
        "countryName": "France"
      },
      {
        "countryKey": "DE",
        "countryName": "Germany"
      },
      {
        "countryKey": "GI",
        "countryName": "Gibraltar"
      },
      {
        "countryKey": "GR",
        "countryName": "Greece"
      },
      {
        "countryKey": "HU",
        "countryName": "Hungary"
      },
      {
        "countryKey": "IE",
        "countryName": "Ireland"
      },
      {
        "countryKey": "IT",
        "countryName": "Italy"
      },
      {
        "countryKey": "LV",
        "countryName": "Latvia"
      },
      {
        "countryKey": "LI",
        "countryName": "Liechtenstein"
      },
      {
        "countryKey": "LT",
        "countryName": "Lithuania"
      },
      {
        "countryKey": "LU",
        "countryName": "Luxemburg"
      },
      {
        "countryKey": "MT",
        "countryName": "Malta"
      },
      {
        "countryKey": "MC",
        "countryName": "Monaco"
      },
      {
        "countryKey": "NL",
        "countryName": "Netherlands"
      },
      {
        "countryKey": "NO",
        "countryName": "Norway"
      },
      {
        "countryKey": "PT",
        "countryName": "Portugal"
      },
      {
        "countryKey": "RO",
        "countryName": "Romania"
      },
      {
        "countryKey": "RS",
        "countryName": "Serbia"
      },
      {
        "countryKey": "SK",
        "countryName": "Slovakia"
      },
      {
        "countryKey": "SI",
        "countryName": "Slovenia"
      },
      {
        "countryKey": "ES",
        "countryName": "Spain"
      },
      {
        "countryKey": "SE",
        "countryName": "Sweden"
      },
      {
        "countryKey": "CH",
        "countryName": "Switzerland"
      },
      {
        "countryKey": "GB",
        "countryName": "United Kingdom"
      },
      {
        "countryKey": "VA",
        "countryName": "Vatican City"
      }
    ]
  },
  {
    "tenantKey": "GLS_BE",
    "tomorrowPickUpCutOffTime": "23:00",
    "countryKey": "BE",
    "maxParcelWeightThreshold": "40",
    "countryName": "Belgium",
    "onboarded": false,
    "validDeliveryCountries": [
      {
        "countryKey": "AD",
        "countryName": "Andorra"
      },
      {
        "countryKey": "AT",
        "countryName": "Austria"
      },
      {
        "countryKey": "BG",
        "countryName": "Bulgaria"
      },
      {
        "countryKey": "HR",
        "countryName": "Croatia"
      },
      {
        "countryKey": "CY",
        "countryName": "Cyprus"
      },
      {
        "countryKey": "CZ",
        "countryName": "Czech Republic"
      },
      {
        "countryKey": "DK",
        "countryName": "Denmark"
      },
      {
        "countryKey": "EE",
        "countryName": "Estonia"
      },
      {
        "countryKey": "FI",
        "countryName": "Finland"
      },
      {
        "countryKey": "FR",
        "countryName": "France"
      },
      {
        "countryKey": "DE",
        "countryName": "Germany"
      },
      {
        "countryKey": "GI",
        "countryName": "Gibraltar"
      },
      {
        "countryKey": "GR",
        "countryName": "Greece"
      },
      {
        "countryKey": "HU",
        "countryName": "Hungary"
      },
      {
        "countryKey": "IE",
        "countryName": "Ireland"
      },
      {
        "countryKey": "IT",
        "countryName": "Italy"
      },
      {
        "countryKey": "LV",
        "countryName": "Latvia"
      },
      {
        "countryKey": "LI",
        "countryName": "Liechtenstein"
      },
      {
        "countryKey": "LT",
        "countryName": "Lithuania"
      },
      {
        "countryKey": "LU",
        "countryName": "Luxemburg"
      },
      {
        "countryKey": "MT",
        "countryName": "Malta"
      },
      {
        "countryKey": "MC",
        "countryName": "Monaco"
      },
      {
        "countryKey": "NL",
        "countryName": "Netherlands"
      },
      {
        "countryKey": "NO",
        "countryName": "Norway"
      },
      {
        "countryKey": "PT",
        "countryName": "Portugal"
      },
      {
        "countryKey": "RO",
        "countryName": "Romania"
      },
      {
        "countryKey": "RS",
        "countryName": "Serbia"
      },
      {
        "countryKey": "SK",
        "countryName": "Slovakia"
      },
      {
        "countryKey": "SI",
        "countryName": "Slovenia"
      },
      {
        "countryKey": "ES",
        "countryName": "Spain"
      },
      {
        "countryKey": "SE",
        "countryName": "Sweden"
      },
      {
        "countryKey": "CH",
        "countryName": "Switzerland"
      },
      {
        "countryKey": "GB",
        "countryName": "United Kingdom"
      },
      {
        "countryKey": "VA",
        "countryName": "Vatican City"
      }
    ]
  },
  {
    "tenantKey": "GLS_FI",
    "tomorrowPickUpCutOffTime": "16:00",
    "countryKey": "FI",
    "maxParcelWeightThreshold": "40",
    "countryName": "Finland",
    "onboarded": true,
    "validDeliveryCountries": [
      {
        "countryKey": "AD",
        "countryName": "Andorra"
      },
      {
        "countryKey": "AT",
        "countryName": "Austria"
      },
      {
        "countryKey": "BE",
        "countryName": "Belgium"
      },
      {
        "countryKey": "BG",
        "countryName": "Bulgaria"
      },
      {
        "countryKey": "HR",
        "countryName": "Croatia"
      },
      {
        "countryKey": "CY",
        "countryName": "Cyprus"
      },
      {
        "countryKey": "CZ",
        "countryName": "Czech Republic"
      },
      {
        "countryKey": "DK",
        "countryName": "Denmark"
      },
      {
        "countryKey": "EE",
        "countryName": "Estonia"
      },
      {
        "countryKey": "FR",
        "countryName": "France"
      },
      {
        "countryKey": "DE",
        "countryName": "Germany"
      },
      {
        "countryKey": "GI",
        "countryName": "Gibraltar"
      },
      {
        "countryKey": "GR",
        "countryName": "Greece"
      },
      {
        "countryKey": "HU",
        "countryName": "Hungary"
      },
      {
        "countryKey": "IE",
        "countryName": "Ireland"
      },
      {
        "countryKey": "IT",
        "countryName": "Italy"
      },
      {
        "countryKey": "LV",
        "countryName": "Latvia"
      },
      {
        "countryKey": "LI",
        "countryName": "Liechtenstein"
      },
      {
        "countryKey": "LT",
        "countryName": "Lithuania"
      },
      {
        "countryKey": "LU",
        "countryName": "Luxemburg"
      },
      {
        "countryKey": "MT",
        "countryName": "Malta"
      },
      {
        "countryKey": "MC",
        "countryName": "Monaco"
      },
      {
        "countryKey": "NL",
        "countryName": "Netherlands"
      },
      {
        "countryKey": "NO",
        "countryName": "Norway"
      },
      {
        "countryKey": "PT",
        "countryName": "Portugal"
      },
      {
        "countryKey": "RO",
        "countryName": "Romania"
      },
      {
        "countryKey": "RS",
        "countryName": "Serbia"
      },
      {
        "countryKey": "SK",
        "countryName": "Slovakia"
      },
      {
        "countryKey": "SI",
        "countryName": "Slovenia"
      },
      {
        "countryKey": "ES",
        "countryName": "Spain"
      },
      {
        "countryKey": "SE",
        "countryName": "Sweden"
      },
      {
        "countryKey": "CH",
        "countryName": "Switzerland"
      },
      {
        "countryKey": "GB",
        "countryName": "United Kingdom"
      },
      {
        "countryKey": "VA",
        "countryName": "Vatican City"
      }
    ]
  },
  {
    "tenantKey": "GLS_PT",
    "tomorrowPickUpCutOffTime": "16:00",
    "countryKey": "PT",
    "maxParcelWeightThreshold": "40",
    "countryName": "Portugal",
    "onboarded": false,
    "validDeliveryCountries": [
      {
        "countryKey": "AD",
        "countryName": "Andorra"
      },
      {
        "countryKey": "AT",
        "countryName": "Austria"
      },
      {
        "countryKey": "BE",
        "countryName": "Belgium"
      },
      {
        "countryKey": "BG",
        "countryName": "Bulgaria"
      },
      {
        "countryKey": "HR",
        "countryName": "Croatia"
      },
      {
        "countryKey": "CY",
        "countryName": "Cyprus"
      },
      {
        "countryKey": "CZ",
        "countryName": "Czech Republic"
      },
      {
        "countryKey": "DK",
        "countryName": "Denmark"
      },
      {
        "countryKey": "EE",
        "countryName": "Estonia"
      },
      {
        "countryKey": "FI",
        "countryName": "Finland"
      },
      {
        "countryKey": "FR",
        "countryName": "France"
      },
      {
        "countryKey": "DE",
        "countryName": "Germany"
      },
      {
        "countryKey": "GI",
        "countryName": "Gibraltar"
      },
      {
        "countryKey": "GR",
        "countryName": "Greece"
      },
      {
        "countryKey": "HU",
        "countryName": "Hungary"
      },
      {
        "countryKey": "IE",
        "countryName": "Ireland"
      },
      {
        "countryKey": "IT",
        "countryName": "Italy"
      },
      {
        "countryKey": "LV",
        "countryName": "Latvia"
      },
      {
        "countryKey": "LI",
        "countryName": "Liechtenstein"
      },
      {
        "countryKey": "LT",
        "countryName": "Lithuania"
      },
      {
        "countryKey": "LU",
        "countryName": "Luxemburg"
      },
      {
        "countryKey": "MT",
        "countryName": "Malta"
      },
      {
        "countryKey": "NL",
        "countryName": "Netherlands"
      },
      {
        "countryKey": "NO",
        "countryName": "Norway"
      },
      {
        "countryKey": "RO",
        "countryName": "Romania"
      },
      {
        "countryKey": "RS",
        "countryName": "Serbia"
      },
      {
        "countryKey": "SK",
        "countryName": "Slovakia"
      },
      {
        "countryKey": "SI",
        "countryName": "Slovenia"
      },
      {
        "countryKey": "ES",
        "countryName": "Spain"
      },
      {
        "countryKey": "SE",
        "countryName": "Sweden"
      },
      {
        "countryKey": "CH",
        "countryName": "Switzerland"
      },
      {
        "countryKey": "GB",
        "countryName": "United Kingdom"
      },
      {
        "countryKey": "VA",
        "countryName": "Vatican City"
      }
    ]
  },
  {
    "tenantKey": "GLS_PL",
    "countryKey": "PL",
    "tomorrowPickUpCutOffTime": "23:00",
    "maxParcelWeightThreshold": "40",
    "countryName": "Poland",
    "onboarded": false,
    "validDeliveryCountries": [
      {
        "countryKey": "AD",
        "countryName": "Andorra"
      },
      {
        "countryKey": "AT",
        "countryName": "Austria"
      },
      {
        "countryKey": "BE",
        "countryName": "Belgium"
      },
      {
        "countryKey": "BG",
        "countryName": "Bulgaria"
      },
      {
        "countryKey": "HR",
        "countryName": "Croatia"
      },
      {
        "countryKey": "CY",
        "countryName": "Cyprus"
      },
      {
        "countryKey": "CZ",
        "countryName": "Czech Republic"
      },
      {
        "countryKey": "DK",
        "countryName": "Denmark"
      },
      {
        "countryKey": "EE",
        "countryName": "Estonia"
      },
      {
        "countryKey": "FI",
        "countryName": "Finland"
      },
      {
        "countryKey": "FR",
        "countryName": "France"
      },
      {
        "countryKey": "DE",
        "countryName": "Germany"
      },
      {
        "countryKey": "GI",
        "countryName": "Gibraltar"
      },
      {
        "countryKey": "GR",
        "countryName": "Greece"
      },
      {
        "countryKey": "HU",
        "countryName": "Hungary"
      },
      {
        "countryKey": "IE",
        "countryName": "Ireland"
      },
      {
        "countryKey": "IT",
        "countryName": "Italy"
      },
      {
        "countryKey": "LV",
        "countryName": "Latvia"
      },
      {
        "countryKey": "LI",
        "countryName": "Liechtenstein"
      },
      {
        "countryKey": "LT",
        "countryName": "Lithuania"
      },
      {
        "countryKey": "LU",
        "countryName": "Luxemburg"
      },
      {
        "countryKey": "MT",
        "countryName": "Malta"
      },
      {
        "countryKey": "NL",
        "countryName": "Netherlands"
      },
      {
        "countryKey": "PT",
        "countryName": "Portugal"
      },
      {
        "countryKey": "RO",
        "countryName": "Romania"
      },
      {
        "countryKey": "RS",
        "countryName": "Serbia"
      },
      {
        "countryKey": "SK",
        "countryName": "Slovakia"
      },
      {
        "countryKey": "SI",
        "countryName": "Slovenia"
      },
      {
        "countryKey": "ES",
        "countryName": "Spain"
      },
      {
        "countryKey": "SE",
        "countryName": "Sweden"
      },
      {
        "countryKey": "CH",
        "countryName": "Switzerland"
      },
      {
        "countryKey": "GB",
        "countryName": "United Kingdom"
      },
      {
        "countryKey": "VA",
        "countryName": "Vatican City"
      }
    ]
  },
  {
    "tenantKey": "PARTNER_MTPOST",
    "tomorrowPickUpCutOffTime": "16:00",
    "countryKey": "MT",
    "maxParcelWeightThreshold": "40",
    "countryName": "Malta",
    "onboarded": true,
    "validDeliveryCountries": [
      {
        "countryKey": "AD",
        "countryName": "Andorra"
      },
      {
        "countryKey": "AT",
        "countryName": "Austria"
      },
      {
        "countryKey": "BE",
        "countryName": "Belgium"
      },
      {
        "countryKey": "BG",
        "countryName": "Bulgaria"
      },
      {
        "countryKey": "HR",
        "countryName": "Croatia"
      },
      {
        "countryKey": "CY",
        "countryName": "Cyprus"
      },
      {
        "countryKey": "CZ",
        "countryName": "Czech Republic"
      },
      {
        "countryKey": "DK",
        "countryName": "Denmark"
      },
      {
        "countryKey": "EE",
        "countryName": "Estonia"
      },
      {
        "countryKey": "FI",
        "countryName": "Finland"
      },
      {
        "countryKey": "FR",
        "countryName": "France"
      },
      {
        "countryKey": "DE",
        "countryName": "Germany"
      },
      {
        "countryKey": "GI",
        "countryName": "Gibraltar"
      },
      {
        "countryKey": "GR",
        "countryName": "Greece"
      },
      {
        "countryKey": "HU",
        "countryName": "Hungary"
      },
      {
        "countryKey": "IE",
        "countryName": "Ireland"
      },
      {
        "countryKey": "IT",
        "countryName": "Italy"
      },
      {
        "countryKey": "LV",
        "countryName": "Latvia"
      },
      {
        "countryKey": "LI",
        "countryName": "Liechtenstein"
      },
      {
        "countryKey": "LT",
        "countryName": "Lithuania"
      },
      {
        "countryKey": "LU",
        "countryName": "Luxemburg"
      },
      {
        "countryKey": "MC",
        "countryName": "Monaco"
      },
      {
        "countryKey": "NL",
        "countryName": "Netherlands"
      },
      {
        "countryKey": "NO",
        "countryName": "Norway"
      },
      {
        "countryKey": "PT",
        "countryName": "Portugal"
      },
      {
        "countryKey": "RO",
        "countryName": "Romania"
      },
      {
        "countryKey": "RS",
        "countryName": "Serbia"
      },
      {
        "countryKey": "SK",
        "countryName": "Slovakia"
      },
      {
        "countryKey": "SI",
        "countryName": "Slovenia"
      },
      {
        "countryKey": "ES",
        "countryName": "Spain"
      },
      {
        "countryKey": "SE",
        "countryName": "Sweden"
      },
      {
        "countryKey": "CH",
        "countryName": "Switzerland"
      },
      {
        "countryKey": "GB",
        "countryName": "United Kingdom"
      },
      {
        "countryKey": "VA",
        "countryName": "Vatican City"
      }
    ]
  },
  {
    "tenantKey": "GLS_DE",
    "tomorrowPickUpCutOffTime": "02:00",
    "countryKey": "DE",
    "maxParcelWeightThreshold": "40",
    "countryName": "Germany",
    "onboarded": false,
    "validDeliveryCountries": [
      {
        "countryKey": "AD",
        "countryName": "Andorra"
      },
      {
        "countryKey": "AT",
        "countryName": "Austria"
      },
      {
        "countryKey": "BE",
        "countryName": "Belgium"
      },
      {
        "countryKey": "BG",
        "countryName": "Bulgaria"
      },
      {
        "countryKey": "HR",
        "countryName": "Croatia"
      },
      {
        "countryKey": "CY",
        "countryName": "Cyprus"
      },
      {
        "countryKey": "CZ",
        "countryName": "Czech Republic"
      },
      {
        "countryKey": "DK",
        "countryName": "Denmark"
      },
      {
        "countryKey": "EE",
        "countryName": "Estonia"
      },
      {
        "countryKey": "FI",
        "countryName": "Finland"
      },
      {
        "countryKey": "FR",
        "countryName": "France"
      },
      {
        "countryKey": "GI",
        "countryName": "Gibraltar"
      },
      {
        "countryKey": "GR",
        "countryName": "Greece"
      },
      {
        "countryKey": "HU",
        "countryName": "Hungary"
      },
      {
        "countryKey": "IE",
        "countryName": "Ireland"
      },
      {
        "countryKey": "IT",
        "countryName": "Italy"
      },
      {
        "countryKey": "LV",
        "countryName": "Latvia"
      },
      {
        "countryKey": "LI",
        "countryName": "Liechtenstein"
      },
      {
        "countryKey": "LT",
        "countryName": "Lithuania"
      },
      {
        "countryKey": "LU",
        "countryName": "Luxemburg"
      },
      {
        "countryKey": "MT",
        "countryName": "Malta"
      },
      {
        "countryKey": "MC",
        "countryName": "Monaco"
      },
      {
        "countryKey": "NL",
        "countryName": "Netherlands"
      },
      {
        "countryKey": "NO",
        "countryName": "Norway"
      },
      {
        "countryKey": "PT",
        "countryName": "Portugal"
      },
      {
        "countryKey": "RO",
        "countryName": "Romania"
      },
      {
        "countryKey": "RS",
        "countryName": "Serbia"
      },
      {
        "countryKey": "SK",
        "countryName": "Slovakia"
      },
      {
        "countryKey": "SI",
        "countryName": "Slovenia"
      },
      {
        "countryKey": "ES",
        "countryName": "Spain"
      },
      {
        "countryKey": "SE",
        "countryName": "Sweden"
      },
      {
        "countryKey": "CH",
        "countryName": "Switzerland"
      },
      {
        "countryKey": "GB",
        "countryName": "United Kingdom"
      },
      {
        "countryKey": "VA",
        "countryName": "Vatican City"
      }
    ]
  },
  {
    "tenantKey": "GLS_RO",
    "tomorrowPickUpCutOffTime": "16:00",
    "countryKey": "RO",
    "maxParcelWeightThreshold": "40",
    "countryName": "Romania",
    "onboarded": true,
    "validDeliveryCountries": [
      {
        "countryKey": "AD",
        "countryName": "Andorra"
      },
      {
        "countryKey": "AT",
        "countryName": "Austria"
      },
      {
        "countryKey": "BE",
        "countryName": "Belgium"
      },
      {
        "countryKey": "BG",
        "countryName": "Bulgaria"
      },
      {
        "countryKey": "HR",
        "countryName": "Croatia"
      },
      {
        "countryKey": "CY",
        "countryName": "Cyprus"
      },
      {
        "countryKey": "CZ",
        "countryName": "Czech Republic"
      },
      {
        "countryKey": "DK",
        "countryName": "Denmark"
      },
      {
        "countryKey": "EE",
        "countryName": "Estonia"
      },
      {
        "countryKey": "FI",
        "countryName": "Finland"
      },
      {
        "countryKey": "FR",
        "countryName": "France"
      },
      {
        "countryKey": "DE",
        "countryName": "Germany"
      },
      {
        "countryKey": "GI",
        "countryName": "Gibraltar"
      },
      {
        "countryKey": "GR",
        "countryName": "Greece"
      },
      {
        "countryKey": "HU",
        "countryName": "Hungary"
      },
      {
        "countryKey": "IE",
        "countryName": "Ireland"
      },
      {
        "countryKey": "IT",
        "countryName": "Italy"
      },
      {
        "countryKey": "LV",
        "countryName": "Latvia"
      },
      {
        "countryKey": "LI",
        "countryName": "Liechtenstein"
      },
      {
        "countryKey": "LT",
        "countryName": "Lithuania"
      },
      {
        "countryKey": "LU",
        "countryName": "Luxemburg"
      },
      {
        "countryKey": "MT",
        "countryName": "Malta"
      },
      {
        "countryKey": "MC",
        "countryName": "Monaco"
      },
      {
        "countryKey": "NL",
        "countryName": "Netherlands"
      },
      {
        "countryKey": "NO",
        "countryName": "Norway"
      },
      {
        "countryKey": "PT",
        "countryName": "Portugal"
      },
      {
        "countryKey": "RS",
        "countryName": "Serbia"
      },
      {
        "countryKey": "SK",
        "countryName": "Slovakia"
      },
      {
        "countryKey": "SI",
        "countryName": "Slovenia"
      },
      {
        "countryKey": "ES",
        "countryName": "Spain"
      },
      {
        "countryKey": "SE",
        "countryName": "Sweden"
      },
      {
        "countryKey": "CH",
        "countryName": "Switzerland"
      },
      {
        "countryKey": "GB",
        "countryName": "United Kingdom"
      },
      {
        "countryKey": "VA",
        "countryName": "Vatican City"
      }
    ]
  },
  {
    "countryKey": "SA",
    "maxParcelWeightThreshold": "40",
    "countryName": "San Marino",
    "onboarded": false,
    "validDeliveryCountries": []
  },
  {
    "tenantKey": "GLS_NL",
    "tomorrowPickUpCutOffTime": "23:00",
    "countryKey": "NL",
    "maxParcelWeightThreshold": "40",
    "countryName": "Netherlands",
    "onboarded": false,
    "validDeliveryCountries": [
      {
        "countryKey": "AD",
        "countryName": "Andorra"
      },
      {
        "countryKey": "AT",
        "countryName": "Austria"
      },
      {
        "countryKey": "BE",
        "countryName": "Belgium"
      },
      {
        "countryKey": "BG",
        "countryName": "Bulgaria"
      },
      {
        "countryKey": "HR",
        "countryName": "Croatia"
      },
      {
        "countryKey": "CY",
        "countryName": "Cyprus"
      },
      {
        "countryKey": "CZ",
        "countryName": "Czech Republic"
      },
      {
        "countryKey": "DK",
        "countryName": "Denmark"
      },
      {
        "countryKey": "EE",
        "countryName": "Estonia"
      },
      {
        "countryKey": "FI",
        "countryName": "Finland"
      },
      {
        "countryKey": "FR",
        "countryName": "France"
      },
      {
        "countryKey": "DE",
        "countryName": "Germany"
      },
      {
        "countryKey": "GR",
        "countryName": "Greece"
      },
      {
        "countryKey": "HU",
        "countryName": "Hungary"
      },
      {
        "countryKey": "IE",
        "countryName": "Ireland"
      },
      {
        "countryKey": "IT",
        "countryName": "Italy"
      },
      {
        "countryKey": "LV",
        "countryName": "Latvia"
      },
      {
        "countryKey": "LI",
        "countryName": "Liechtenstein"
      },
      {
        "countryKey": "LT",
        "countryName": "Lithuania"
      },
      {
        "countryKey": "LU",
        "countryName": "Luxemburg"
      },
      {
        "countryKey": "MT",
        "countryName": "Malta"
      },
      {
        "countryKey": "MC",
        "countryName": "Monaco"
      },
      {
        "countryKey": "NO",
        "countryName": "Norway"
      },
      {
        "countryKey": "PT",
        "countryName": "Portugal"
      },
      {
        "countryKey": "RO",
        "countryName": "Romania"
      },
      {
        "countryKey": "RS",
        "countryName": "Serbia"
      },
      {
        "countryKey": "SK",
        "countryName": "Slovakia"
      },
      {
        "countryKey": "SI",
        "countryName": "Slovenia"
      },
      {
        "countryKey": "ES",
        "countryName": "Spain"
      },
      {
        "countryKey": "SE",
        "countryName": "Sweden"
      },
      {
        "countryKey": "CH",
        "countryName": "Switzerland"
      },
      {
        "countryKey": "VA",
        "countryName": "Vatican City"
      }
    ]
  },
  {
    "tenantKey": "PARTNER_POSTNO",
    "tomorrowPickUpCutOffTime": "16:00",
    "countryKey": "NO",
    "maxParcelWeightThreshold": "40",
    "countryName": "Norway",
    "onboarded": true,
    "validDeliveryCountries": [
      {
        "countryKey": "AD",
        "countryName": "Andorra"
      },
      {
        "countryKey": "AT",
        "countryName": "Austria"
      },
      {
        "countryKey": "BE",
        "countryName": "Belgium"
      },
      {
        "countryKey": "BG",
        "countryName": "Bulgaria"
      },
      {
        "countryKey": "HR",
        "countryName": "Croatia"
      },
      {
        "countryKey": "CY",
        "countryName": "Cyprus"
      },
      {
        "countryKey": "CZ",
        "countryName": "Czech Republic"
      },
      {
        "countryKey": "DK",
        "countryName": "Denmark"
      },
      {
        "countryKey": "EE",
        "countryName": "Estonia"
      },
      {
        "countryKey": "FI",
        "countryName": "Finland"
      },
      {
        "countryKey": "FR",
        "countryName": "France"
      },
      {
        "countryKey": "DE",
        "countryName": "Germany"
      },
      {
        "countryKey": "GI",
        "countryName": "Gibraltar"
      },
      {
        "countryKey": "GR",
        "countryName": "Greece"
      },
      {
        "countryKey": "HU",
        "countryName": "Hungary"
      },
      {
        "countryKey": "IE",
        "countryName": "Ireland"
      },
      {
        "countryKey": "IT",
        "countryName": "Italy"
      },
      {
        "countryKey": "LV",
        "countryName": "Latvia"
      },
      {
        "countryKey": "LI",
        "countryName": "Liechtenstein"
      },
      {
        "countryKey": "LT",
        "countryName": "Lithuania"
      },
      {
        "countryKey": "LU",
        "countryName": "Luxemburg"
      },
      {
        "countryKey": "MT",
        "countryName": "Malta"
      },
      {
        "countryKey": "MC",
        "countryName": "Monaco"
      },
      {
        "countryKey": "NL",
        "countryName": "Netherlands"
      },
      {
        "countryKey": "PT",
        "countryName": "Portugal"
      },
      {
        "countryKey": "RO",
        "countryName": "Romania"
      },
      {
        "countryKey": "RS",
        "countryName": "Serbia"
      },
      {
        "countryKey": "SK",
        "countryName": "Slovakia"
      },
      {
        "countryKey": "SI",
        "countryName": "Slovenia"
      },
      {
        "countryKey": "ES",
        "countryName": "Spain"
      },
      {
        "countryKey": "SE",
        "countryName": "Sweden"
      },
      {
        "countryKey": "CH",
        "countryName": "Switzerland"
      },
      {
        "countryKey": "GB",
        "countryName": "United Kingdom"
      },
      {
        "countryKey": "VA",
        "countryName": "Vatican City"
      }
    ]
  },
  {
    "tenantKey": "GLS_CZ",
    "tomorrowPickUpCutOffTime": "16:00",
    "countryKey": "CZ",
    "maxParcelWeightThreshold": "40",
    "countryName": "Czech Republic",
    "onboarded": true,
    "validDeliveryCountries": [
      {
        "countryKey": "AD",
        "countryName": "Andorra"
      },
      {
        "countryKey": "AT",
        "countryName": "Austria"
      },
      {
        "countryKey": "BE",
        "countryName": "Belgium"
      },
      {
        "countryKey": "BG",
        "countryName": "Bulgaria"
      },
      {
        "countryKey": "HR",
        "countryName": "Croatia"
      },
      {
        "countryKey": "CY",
        "countryName": "Cyprus"
      },
      {
        "countryKey": "DK",
        "countryName": "Denmark"
      },
      {
        "countryKey": "EE",
        "countryName": "Estonia"
      },
      {
        "countryKey": "FI",
        "countryName": "Finland"
      },
      {
        "countryKey": "FR",
        "countryName": "France"
      },
      {
        "countryKey": "DE",
        "countryName": "Germany"
      },
      {
        "countryKey": "GI",
        "countryName": "Gibraltar"
      },
      {
        "countryKey": "GR",
        "countryName": "Greece"
      },
      {
        "countryKey": "HU",
        "countryName": "Hungary"
      },
      {
        "countryKey": "IE",
        "countryName": "Ireland"
      },
      {
        "countryKey": "IT",
        "countryName": "Italy"
      },
      {
        "countryKey": "LV",
        "countryName": "Latvia"
      },
      {
        "countryKey": "LI",
        "countryName": "Liechtenstein"
      },
      {
        "countryKey": "LT",
        "countryName": "Lithuania"
      },
      {
        "countryKey": "LU",
        "countryName": "Luxemburg"
      },
      {
        "countryKey": "MT",
        "countryName": "Malta"
      },
      {
        "countryKey": "MC",
        "countryName": "Monaco"
      },
      {
        "countryKey": "NL",
        "countryName": "Netherlands"
      },
      {
        "countryKey": "NO",
        "countryName": "Norway"
      },
      {
        "countryKey": "PT",
        "countryName": "Portugal"
      },
      {
        "countryKey": "RO",
        "countryName": "Romania"
      },
      {
        "countryKey": "RS",
        "countryName": "Serbia"
      },
      {
        "countryKey": "SK",
        "countryName": "Slovakia"
      },
      {
        "countryKey": "SI",
        "countryName": "Slovenia"
      },
      {
        "countryKey": "ES",
        "countryName": "Spain"
      },
      {
        "countryKey": "SE",
        "countryName": "Sweden"
      },
      {
        "countryKey": "CH",
        "countryName": "Switzerland"
      },
      {
        "countryKey": "GB",
        "countryName": "United Kingdom"
      },
      {
        "countryKey": "VA",
        "countryName": "Vatican City"
      }
    ]
  },
  {
    "tenantKey": "GLS_AT",
    "tomorrowPickUpCutOffTime": "23:00",
    "countryKey": "AT",
    "maxParcelWeightThreshold": "40",
    "countryName": "Austria",
    "onboarded": false,
    "validDeliveryCountries": [
      {
        "countryKey": "AD",
        "countryName": "Andorra"
      },
      {
        "countryKey": "BE",
        "countryName": "Belgium"
      },
      {
        "countryKey": "BG",
        "countryName": "Bulgaria"
      },
      {
        "countryKey": "HR",
        "countryName": "Croatia"
      },
      {
        "countryKey": "CY",
        "countryName": "Cyprus"
      },
      {
        "countryKey": "CZ",
        "countryName": "Czech Republic"
      },
      {
        "countryKey": "DK",
        "countryName": "Denmark"
      },
      {
        "countryKey": "EE",
        "countryName": "Estonia"
      },
      {
        "countryKey": "FI",
        "countryName": "Finland"
      },
      {
        "countryKey": "FR",
        "countryName": "France"
      },
      {
        "countryKey": "DE",
        "countryName": "Germany"
      },
      {
        "countryKey": "GI",
        "countryName": "Gibraltar"
      },
      {
        "countryKey": "GR",
        "countryName": "Greece"
      },
      {
        "countryKey": "HU",
        "countryName": "Hungary"
      },
      {
        "countryKey": "IE",
        "countryName": "Ireland"
      },
      {
        "countryKey": "IT",
        "countryName": "Italy"
      },
      {
        "countryKey": "LV",
        "countryName": "Latvia"
      },
      {
        "countryKey": "LI",
        "countryName": "Liechtenstein"
      },
      {
        "countryKey": "LT",
        "countryName": "Lithuania"
      },
      {
        "countryKey": "LU",
        "countryName": "Luxemburg"
      },
      {
        "countryKey": "MT",
        "countryName": "Malta"
      },
      {
        "countryKey": "MC",
        "countryName": "Monaco"
      },
      {
        "countryKey": "NL",
        "countryName": "Netherlands"
      },
      {
        "countryKey": "NO",
        "countryName": "Norway"
      },
      {
        "countryKey": "PT",
        "countryName": "Portugal"
      },
      {
        "countryKey": "RO",
        "countryName": "Romania"
      },
      {
        "countryKey": "RS",
        "countryName": "Serbia"
      },
      {
        "countryKey": "SK",
        "countryName": "Slovakia"
      },
      {
        "countryKey": "SI",
        "countryName": "Slovenia"
      },
      {
        "countryKey": "ES",
        "countryName": "Spain"
      },
      {
        "countryKey": "SE",
        "countryName": "Sweden"
      },
      {
        "countryKey": "CH",
        "countryName": "Switzerland"
      },
      {
        "countryKey": "GB",
        "countryName": "United Kingdom"
      },
      {
        "countryKey": "VA",
        "countryName": "Vatican City"
      }
    ]
  },
  {
    "tenantKey": "GLS_AT",
    "tomorrowPickUpCutOffTime": "23:00",
    "countryKey": "LI",
    "maxParcelWeightThreshold": "40",
    "countryName": "Liechtenstein",
    "onboarded": false,
    "validDeliveryCountries": [
      {
        "countryKey": "AD",
        "countryName": "Andorra"
      },
      {
        "countryKey": "AT",
        "countryName": "Austria"
      },
      {
        "countryKey": "BE",
        "countryName": "Belgium"
      },
      {
        "countryKey": "BG",
        "countryName": "Bulgaria"
      },
      {
        "countryKey": "HR",
        "countryName": "Croatia"
      },
      {
        "countryKey": "CY",
        "countryName": "Cyprus"
      },
      {
        "countryKey": "CZ",
        "countryName": "Czech Republic"
      },
      {
        "countryKey": "DK",
        "countryName": "Denmark"
      },
      {
        "countryKey": "EE",
        "countryName": "Estonia"
      },
      {
        "countryKey": "FI",
        "countryName": "Finland"
      },
      {
        "countryKey": "FR",
        "countryName": "France"
      },
      {
        "countryKey": "DE",
        "countryName": "Germany"
      },
      {
        "countryKey": "GI",
        "countryName": "Gibraltar"
      },
      {
        "countryKey": "GR",
        "countryName": "Greece"
      },
      {
        "countryKey": "HU",
        "countryName": "Hungary"
      },
      {
        "countryKey": "IE",
        "countryName": "Ireland"
      },
      {
        "countryKey": "IT",
        "countryName": "Italy"
      },
      {
        "countryKey": "LV",
        "countryName": "Latvia"
      },
      {
        "countryKey": "LT",
        "countryName": "Lithuania"
      },
      {
        "countryKey": "LU",
        "countryName": "Luxemburg"
      },
      {
        "countryKey": "MT",
        "countryName": "Malta"
      },
      {
        "countryKey": "MC",
        "countryName": "Monaco"
      },
      {
        "countryKey": "NL",
        "countryName": "Netherlands"
      },
      {
        "countryKey": "NO",
        "countryName": "Norway"
      },
      {
        "countryKey": "PT",
        "countryName": "Portugal"
      },
      {
        "countryKey": "RO",
        "countryName": "Romania"
      },
      {
        "countryKey": "RS",
        "countryName": "Serbia"
      },
      {
        "countryKey": "SK",
        "countryName": "Slovakia"
      },
      {
        "countryKey": "SI",
        "countryName": "Slovenia"
      },
      {
        "countryKey": "ES",
        "countryName": "Spain"
      },
      {
        "countryKey": "SE",
        "countryName": "Sweden"
      },
      {
        "countryKey": "CH",
        "countryName": "Switzerland"
      },
      {
        "countryKey": "GB",
        "countryName": "United Kingdom"
      },
      {
        "countryKey": "VA",
        "countryName": "Vatican City"
      }
    ]
  }
]
